import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '../../../../app.reducers';

import { LanguageService } from '@shared/services/language.service';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-strategy-portfolio-customer-support',
  templateUrl: './strategy-portfolio-customer-support.component.html',
  styleUrls: ['./strategy-portfolio-customer-support.component.scss'],
  standalone: false
})
export class StrategyPortfolioCustomerSupportComponent implements OnInit {
  protected readonly onDestroy$ = new Subject<void>();
  kind = '3b';
  language: string;
  showGuarantee = false;
  tuvLanguage: string;

  @Input() totalFee = 1.2;

  constructor(
    private trackingService: TrackingService,
    private store: Store,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.tuvLanguage = this.languageService.getRedirectLanguage();

    this.store
      .pipe(select(fromAppRoot.selectCustomerAndCurrentInvestAccount), takeUntil(this.onDestroy$))
      .subscribe(({ customer, currentAccountDetail }) => {
        if (!customer || !customer.email || !currentAccountDetail?.id) {
          return;
        }

        this.language = customer.language;
        this.kind = currentAccountDetail.kind;
      });
  }

  toggleGuaranteeModal(): void {
    this.showGuarantee = !this.showGuarantee;
  }

  trackActivity(activity: string): void {
    this.trackingService.trackActivity(activity);
  }
}
